<template>
  <BlankLayout class="container mx-auto" style="background-color: #FFF7E2">
    <div class="flex flex-col h-full">
      <KioskBanner />
      <!--end::banner-->

      <div class="flex items-center justify-center flex-1 text-center">
        <div class="w-full px-10">
          <BaseImg src="/char-hu-1.png" class="w-32 mx-auto sm:w-48" />

          <p class="my-10 text-2xl v:my-20 v:text-5xl sm:text-3xl">
            키오스를 <span class="font-bold" style="color: #FFC701">나혼자 해낼수 있게,</span> <br />
            도우미 어플리케이션
          </p>

          <div class="w-1/2 w-full mx-auto sm:w-1/4">
            <router-link to="home">
              <button
                class="w-full py-4 mx-auto text-lg font-bold text-white rounded-full sm:py-5 v:text-3xl sm:text-2xl"
                style="background-color: #3A3534"
              >
                시작
              </button>
            </router-link>
          </div>
        </div>
      </div>
      <!--end::content-->

      <KioskFooter class="mt-20" />
      <!--end::footer-->
    </div>
  </BlankLayout>
</template>

<script>
import appConfig from '@src/app.config'
import BlankLayout from '@layouts/blank-layout.vue'
import KioskBanner from '@components/layout/kiosk-banner.vue'
import KioskFooter from '@components/layout/kiosk-footer.vue'

export default {
  page: {
    title: appConfig.title,
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { KioskFooter, KioskBanner, BlankLayout },
}
</script>
